<template>
	<div>
		<BusinessBanner />
		<div class="content-zsy" v-loading="loading" style="min-height: 400px;">
			<InventoryNavi />
			<div class="widget-location">
				<h3>입고보관</h3>
			</div>
			
			<div class="search-card">
				<div class="search-form-inline">
					<div class="form-item-group">
						<span class="form-item-label">선택검색</span>
						<el-select v-model="s" placeholder="" style="width: 110px; margin-right: 6px;">
						    <el-option
						      v-for="item in s_options"
						      :key="item.value"
						      :label="item.label"
						      :value="item.value">
						    </el-option>
						</el-select>
						<el-input v-model="k" placeholder="검색어" class="form-item-input" style="width: 140px !important;" clearable></el-input>
					</div>
					
					<div class="form-item-group">
						<span class="form-item-label">등록일</span>
						<el-date-picker type="date" v-model="date1" placeholder="시작일" style="width: 135px;"></el-date-picker>
						<span style="margin: 0 4px; color: #94a3b8;">~</span>
						<el-date-picker type="date" v-model="date2" placeholder="종료일" style="width: 135px;"></el-date-picker>
					</div>
					
					<div class="form-action-group">
						<el-button type="primary" icon="el-icon-search" @click="changeSearch">검색</el-button>
						<el-button icon="el-icon-refresh" @click="onReset">검색 초기화</el-button>
					</div>
				</div>
			</div>
			<div class="table-list" v-if="!isMobile">
				<div class="page-info" style="display:flex; justify-content:space-between; align-items:center;">
					<span>전체 : <strong>{{total}}</strong> ({{current_page}}/{{last_page}} 페이지)</span>
					<el-button type="warning" size="small" @click="handleRepackApplication" :disabled="multipleSelection.length === 0">포장/조합 (Pack)</el-button>
				</div>
				<el-table
				    :data="tableData"
				    stripe empty-text="데이타가 없습니다."
				    style="width: 100%"
					@selection-change="handleSelectionChange">
					<el-table-column type="selection" width="55"></el-table-column>
					<el-table-column
						label="상태"
						width="100">
						<template slot-scope="scope">
							  <div style="display: flex; justify-content: center;">
								  {{scope.row.status_name}}
							  </div>							
						</template>
					</el-table-column>
				    <el-table-column
				      label="상품정보">
						<template slot-scope="scope">
							<div><a class="scope-a" :href="scope.row.url" target="_blank">{{ scope.row.goods_name }}</a></div>
						</template>
				    </el-table-column>
					<el-table-column label="입고 상세 정보" min-width="320">
					  <template slot-scope="scope">
						<div class="agency-info-row">
						  <!-- 1. 상품코드 -->
						  <div class="info-badge">
							<span class="badge-label">상품코드</span>
							<span class="badge-value">{{ scope.row.code || '-' }}</span>
						  </div>
						  <!-- 2. 배송센터 -->
						  <div class="info-badge">
							<span class="badge-label">배송센터</span>
							<span class="badge-value">해상</span>
						  </div>
						  <!-- 3. 단가 (CNY) -->
						  <div class="info-badge" v-if="scope.row.price">
							<span class="badge-label">단가</span>
							<span class="badge-value" style="color: #ff5700; font-weight: bold;">{{ scope.row.price }} CNY</span>
						  </div>
						  <!-- 4. 색상 -->
						  <div class="info-badge" v-if="scope.row.color">
							<span class="badge-label">색상</span>
							<span class="badge-value">{{ scope.row.color }}</span>
						  </div>
						  <!-- 5. 사이즈 -->
						  <div class="info-badge" v-if="scope.row.size">
							<span class="badge-label">사이즈</span>
							<span class="badge-value">{{ scope.row.size }}</span>
						  </div>
						  <!-- 6. 입고수량 (신청/실제) -->
						  <div class="info-badge">
							<span class="badge-label">입고수량</span>
							<span class="badge-value">
							  <span class="color-blue" style="font-weight: bold;">{{ scope.row.apply_quantity }}</span>
							  <span> / </span>
							  <span>{{ scope.row.stock_qty || 0 }}</span>
							</span>
						  </div>
						  <!-- 7. 등록일 -->
						  <div class="info-badge">
							<span class="badge-label">등록일</span>
							<span class="badge-value">{{ scope.row.createtime_format }}</span>
						  </div>
						  <!-- 8. 입고일 -->
						  <div class="info-badge">
							<span class="badge-label">입고일</span>
							<span class="badge-value">{{ scope.row.warehousetime || '-' }}</span>
						  </div>
						</div>
					  </template>
					</el-table-column>
					<el-table-column label="메뉴" width="240">
					    <template slot-scope="scope">
							<div style="display: flex; flex-wrap: wrap; gap: 6px; align-items: center;">
								<el-button
								  size="mini"  type="primary" plain
								  @click="handleEdit(scope.$index, scope.row)">확인</el-button>
								<el-button
								  size="mini"
								  type="danger" plain
								  @click="handleDelete(scope.$index, scope.row)">삭제</el-button>
							</div>
					    </template>
					</el-table-column>
				  </el-table>
				<div class="block">
				  <el-pagination
				    layout="prev, pager, next"  :page-size="20"
				    :total="total"  @current-change="handleCurrentChange" >
				  </el-pagination>
				</div>
			</div>
			<div v-else class="table-list">
				<div class="page-info">
					<span>전체 : <strong>{{total}}</strong> ({{current_page}}/{{last_page}} 페이지)</span>
				</div>
				
				<div class="info-wrap" v-for="(item,index) in tableData" :key="index" >
					<div class="item-info-wrap">
						<div class="item-status">
							상태: <span>{{item.status_name}}</span>
						</div>
						<div class="info-right-top">
							<span class="item-center">[해상]</span>
							<span class="item-code">상품코드 : {{item.code}}</span>
						</div>
						<div class="info-right-bottom">
							<div class="item-goodsname">
								<a :href="item.url" target="_blank">{{item.goods_name}}</a>
							</div>
						</div>
					</div>
					<div class="item-option-wrap">
						단가: <span class="item-option item-option-price">{{item.price}} CNY</span>, 색상: <span class="item-option item-option-color">{{item.color}}</span>, 사이즈: <span class="item-option item-option-size">{{item.size}}</span>
					</div>
					
					<div class="item-quantity-wrap">
						<div class="item-quantity">
							<div>입고신청 : <span class="color-blue">{{ item.apply_quantity }}</span></div>
							<div>입고 : {{ item.stock_qty?item.stock_qty:0 }}</div>
	
						</div>
					</div>
					<div class="item-date-wrap">
						등록일 : {{ item.createtime_format }} /
						입고일 : {{ item.warehousetime?item.warehousetime:"-" }}                      
					</div>
					
					<div style="display: flex;justify-content: space-between;">
						<!-- <el-button size="mini" plain >트래킹넘버 입력</el-button> -->
						<el-button
						  size="mini"  type="primary" plain
						  @click="handleEdit(index, item)">확인</el-button>
						<el-button
						  size="mini"
						  type="danger" plain
						  @click="handleDelete(index, item)">삭제</el-button>
					</div>		
				</div>
			</div>
			
			<el-dialog title="상세정보" :visible.sync="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false" :width="isMobile?'98%':'1100px'">
					<!-- <div style="display: flex;justify-content:flex-end;margin-bottom: 20px;">
						<el-button type="primary" plain round size="mini" @click="onEdit" >상품수정</el-button>
					</div> -->
					<el-row type="flex" style="flex-wrap: wrap;">
						<el-col :xs="5" :sm="2" class="table-title" >배송센터</el-col>
						<el-col :xs="7" :sm="4" class="table-content">
							<div style="display: flex;flex-direction: column;">
								<div>해상</div>
								<div class="label-warehouse">재고입고</div>
							</div>
						</el-col>
						<el-col :xs="5" :sm="2" class="table-title">아이템번호</el-col>
						<el-col :xs="7" :sm="4" class="table-content">123456<br>(신청접수)</el-col>			
						<el-col :xs="5" :sm="2" class="table-title" >신청서번호</el-col>
						<el-col :xs="7" :sm="4" class="table-content" >-</el-col>
						<el-col :xs="5" :sm="2" class="table-title">등록일</el-col>
						<el-col :xs="7" :sm="4" class="table-content">{{info.createtime}}</el-col>
						
						<el-col :xs="5" :sm="2" class="table-title" >상품명</el-col>
						<el-col :xs="7" :sm="4" class="table-content" >{{info.goods_name}}</el-col>
						<el-col :xs="5" :sm="2" class="table-title">품목분류</el-col>
						<el-col :xs="7" :sm="4" class="table-content">{{info.category}}</el-col>			
						<el-col :xs="5" :sm="2" class="table-title" >관리코드</el-col>
						<el-col :xs="7" :sm="4" class="table-content" >{{info.refer_code}}</el-col>
						<el-col :xs="5" :sm="2" class="table-title">창고도착일</el-col>
						<el-col :xs="7" :sm="4" class="table-content">-</el-col>
						
						<el-col :xs="5" :sm="2" class="table-title" >색상</el-col>
						<el-col :xs="7" :sm="4" class="table-content" >{{info.color}}</el-col>
						<el-col :xs="5" :sm="2" class="table-title">사이즈</el-col>
						<el-col :xs="7" :sm="4" class="table-content">{{info.size}}</el-col>			
						<el-col :xs="5" :sm="2" class="table-title" >재고상품코드</el-col>
						<el-col :xs="7" :sm="4" class="table-content" >{{info.code}}</el-col>
						<el-col :xs="5" :sm="2" class="table-title">입고완료일</el-col>
						<el-col :xs="7" :sm="4" class="table-content">-</el-col>
						
						<el-col :xs="5" :sm="2" class="table-title" >단가</el-col>
						<el-col :xs="7" :sm="4" class="table-content" >{{info.price}} CNY</el-col>
						<el-col :xs="5" :sm="2" class="table-title">주문수량</el-col>
						<el-col :xs="7" :sm="4" class="table-content">{{info.apply_quantity}}</el-col>			
						<el-col :xs="5" :sm="2" class="table-title" >입고수량</el-col>
						<el-col :xs="7" :sm="4" class="table-content" >-</el-col>
						<el-col :xs="5" :sm="2" class="table-title">결제완료일</el-col>
						<el-col :xs="7" :sm="4" class="table-content">-</el-col>
						
						<el-col :xs="5" :sm="2" class="table-title" >오더넘버</el-col>
						<el-col :xs="7" :sm="4" class="table-content" >{{info.order_no}}</el-col>
						<el-col :xs="5" :sm="2" class="table-title">트래킹넘버</el-col>
						<el-col :xs="7" :sm="4" class="table-content">{{info.tracking_no}}</el-col>			
						<el-col :xs="5" :sm="2" class="table-title" >쉬핑네임</el-col>
						<el-col :xs="7" :sm="4" class="table-content" >{{info.ship_name}}</el-col>
						<el-col :xs="5" :sm="2" class="table-title">발송완료일</el-col>
						<el-col :xs="7" :sm="4" class="table-content">-</el-col>
						
						<el-col :xs="5" :sm="2" class="table-title" >상품 관리번호</el-col>
						<el-col :xs="7" :sm="4" class="table-content">-</el-col>
						<el-col :xs="5" :sm="2" class="table-title">포장 박스수량</el-col>
						<el-col :xs="7" :sm="4" class="table-content">-</el-col>			
						<el-col :xs="5" :sm="2" class="table-title" >국내 쇼핑몰</el-col>
						<el-col :xs="7" :sm="4" class="table-content" >-</el-col>
						<el-col :xs="5" :sm="2" class="table-title">배송완료일</el-col>
						<el-col :xs="7" :sm="4" class="table-content">-</el-col>
						
						<el-col :xs="5" :sm="2" class="table-title" >URL</el-col>
						<el-col :xs="19" :sm="10" class="table-content">
							<a :href="info.url" target="_blank">{{info.url}}</a>
						</el-col>
						<el-col :xs="5" :sm="2" class="table-title">입고 요청메세지</el-col>
						<el-col :xs="19" :sm="10" class="table-content">{{info.shipping_memo}}</el-col>			

					</el-row>
			</el-dialog>
			
			<!-- 포장/조합 신청 弹窗 -->
			<el-dialog title="포장/조합 신청 (Pack/Combine)" :visible.sync="repackVisible" :close-on-click-modal="false" :width="isMobile?'96%':'800px'">
				<el-form :model="repackForm" ref="repackForm" label-width="120px">
					<el-form-item label="새 상품명" prop="new_goods_name" :rules="[{ required: true, message: '새 상품명을 입력해주세요', trigger: 'blur' }]">
						<el-input v-model="repackForm.new_goods_name" placeholder="조합된 새 상품명을 입력하세요"></el-input>
					</el-form-item>
					
					<el-form-item label="생산 수량" prop="produce_qty" :rules="[{ required: true, message: '수량을 입력해주세요', trigger: 'blur' }]">
						<el-input-number v-model="repackForm.produce_qty" :min="1" label="포장/조합 수량"></el-input-number>
					</el-form-item>

					<el-form-item label="포장 규격" v-if="multipleSelection.length === 1">
						<div style="display: flex; gap: 10px;">
							<el-select v-model="repackForm.unit_template_id" placeholder="규격 선택(선택사항)" clearable @change="handleTemplateChange" style="flex: 1;">
								<el-option v-for="item in unitTemplates" :key="item.id" :label="item.unit_name" :value="item.id"></el-option>
							</el-select>
							<el-button type="success" size="small" icon="el-icon-plus" @click="handleShowAddTemplate">규격 추가</el-button>
						</div>
					</el-form-item>

					<el-form-item label="구성품 (BOM)">
						<el-table :data="multipleSelection.filter(item => item.stock_qty > 0)" border size="small">
							<el-table-column prop="goods_name" label="상품명"></el-table-column>
							<el-table-column label="세트당 소모량" width="150">
								<template slot-scope="scope">
									<el-input-number v-model="scope.row.unit_qty" :min="1" size="mini" style="width: 100%"></el-input-number>
								</template>
							</el-table-column>
							<el-table-column label="예상 총 소모량" width="120">
								<template slot-scope="scope">
									{{ (scope.row.unit_qty || 1) * repackForm.produce_qty }}
								</template>
							</el-table-column>
							<el-table-column label="보유 재고" width="100">
								<template slot-scope="scope">
									{{ scope.row.stock_qty || 0 }}
								</template>
							</el-table-column>
						</el-table>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="repackVisible = false">취소</el-button>
					<el-button type="primary" @click="submitRepack">신청하기</el-button>
				</div>
			</el-dialog>

			<el-dialog title="포장 규격 추가" :visible.sync="templateDialogVisible" append-to-body :width="isMobile?'90%':'400px'">
				<el-form :model="templateForm" ref="templateForm" label-width="80px">
					<el-form-item label="규격명" prop="unit_name" :rules="[{ required: true, message: '규격명을 입력하세요', trigger: 'blur' }]">
						<el-input v-model="templateForm.unit_name" placeholder="예: 1박스 (12개입)"></el-input>
					</el-form-item>
					<el-form-item label="포함수량" prop="ratio" :rules="[{ required: true, message: '수량을 입력하세요', trigger: 'blur' }]">
						<el-input-number v-model="templateForm.ratio" :min="1" style="width: 100%"></el-input-number>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="templateDialogVisible = false">취소</el-button>
					<el-button type="primary" @click="submitAddTemplate">저장</el-button>
				</div>
			</el-dialog>

			<!-- <el-dialog title="수정하기" :visible.sync="editVisible" :close-on-click-modal="false" :close-on-press-escape="false" :width="isMobile?'96%':'800px'">
				<el-form :model="form"  ref="ruleForm" label-width="0" >
					
					<div class="form-item" >
						<el-row>
							<el-col :xs="24" :sm="12"  class="item">
								<div class="from-title">상품명(영문) <span class="required-addon">(*)</span>
								<el-popover
								   placement="top-start"
								   width="300"
								   trigger="hover"
								   >
								   <div>검색(HS코드네비게이션)에서 보다 정확한 결과를 얻을수 있습니다</div>
										<i class="el-icon-question icon-question" slot="reference"></i>
								</el-popover>
								</div>
								<el-form-item  prop="goods_name"
								:rules="[
									{ required: true, message: '상품명 필수', trigger: 'blur' },
								]">
									<el-input v-model="form.goods_name" class="input-frame" ></el-input>			
								</el-form-item>
							</el-col>
							<el-col :xs="24" :sm="12"  class="item">
								<div class="from-title">상품코드 <span class="required-addon">(*)</span>
								<el-popover
								   placement="top-start"
								   width="300"
								   trigger="hover"
								   >
								    <div>국내마켓 상품관리에 필요한 상품코드를 입력 관리해보세요</div>
									<i class="el-icon-question icon-question" slot="reference"></i>
								 </el-popover>
								</div>
								<el-form-item  prop="code" :rules="[
									{ required: true, message: '상품코드 필수', trigger: 'blur' },
								]">
									<el-input v-model="form.code" class="input-frame" ></el-input>
								</el-form-item>
							</el-col>
							<el-col :xs="24" :sm="12"  class="item">
								<div class="from-title">관리코드 
								<el-popover
								   placement="top-start"
								   width="300"
								   trigger="hover"
								   >
								    <div>관리코드를 부여해서 관리해보세요</div>
									<i class="el-icon-question icon-question" slot="reference"></i>
								 </el-popover>
								</div>
								<el-form-item  prop="refer_code">
									<el-input v-model="form.refer_code" class="input-frame" ></el-input>
								</el-form-item>
							</el-col>
							<el-col :xs="24" :sm="12"  class="item">
								<div class="from-title">주문번호 <span class="required-addon">(*)</span>
								<el-popover
								   placement="top-start"
								   width="300"
								   trigger="hover"
								   >
								    <div>구매 주문번호를 입력해주세요</div>
									<i class="el-icon-question icon-question" slot="reference"></i>
								 </el-popover>
								</div>
								<el-form-item  prop="order_no" :rules="[
									{ required: true, message: '주문번호 필수', trigger: 'blur' },
								]">
									<el-input v-model="form.order_no" class="input-frame" ></el-input>
								</el-form-item>
							</el-col>
							<el-col :xs="24" :sm="12"  class="item">
								<div class="from-title">트래킹넘버 <span class="required-addon">(*)</span>
								<el-popover
								   placement="top-start"
								   width="300"
								   trigger="hover"
								   >
								    <div>판매자 상품발송후 제공된 트래킹번호를 즉시 입력해주세요<br>입력이 안될경우 노데이터로 분류되어서 입고가 지연됩니다</div>
									<i class="el-icon-question icon-question" slot="reference"></i>
								 </el-popover>
								</div>
								<el-form-item  prop="tracking_no" :rules="[
									{ required: true, message: '트래킹넘버 필수', trigger: 'blur' },
								]">
									<el-input v-model="form.tracking_no" class="input-frame" placeholder="여러개 입력시 ,(콤마)"></el-input>
								</el-form-item>
							</el-col>
							<el-col :xs="24" :sm="12"  class="item">
								<div class="from-title">수량 <span class="required-addon">(*)</span></div>
								<el-form-item  prop="apply_quantity"
								:rules="[
									{ required: true, message: '수량 필수', trigger: 'blur' },
								]">
								<div style="display: flex;">
									<el-input v-model="form.apply_quantity" type="number" class="input-frame"  ></el-input>
									<div>개</div>
								</div>
								</el-form-item>
							</el-col>
							<el-col :xs="24" :sm="12"  class="item">
								<div class="from-title">요청메세지 </div>
								<el-form-item  prop="shipping_memo">
									<el-input v-model="form.shipping_memo" placeholder="30자 이내로 적어주세요."  class="input-frame"  ></el-input>
								</el-form-item>
							</el-col>
							<el-col :xs="24" :sm="12"  class="item">
								<div class="from-title">쉬핑네임 </div>
								<el-form-item  prop="ship_name" >
									<el-input v-model="form.ship_name"  class="input-frame" ></el-input>
								</el-form-item>
							</el-col>
				
						</el-row>
					</div>
					
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button type="primary" @click="submitForm('ruleForm')">수정하기</el-button>
				</div>
			</el-dialog> -->
			
			
		</div>
		
	</div>
</template>

<script>
	import BusinessBanner from '../../components/BusinessBanner.vue'
	import InventoryNavi from '../../components/InventoryNavi.vue'
	import request from '@/utils/request'
	export default {
		components: {
			BusinessBanner,
			InventoryNavi
		},
		data() {
			return{
				loading: true,
				s_options: [{
				  value: 'code',
				  label: '상품코드'
				}, {
				  value: 'refer_code',
				  label: '관리코드'
				}, {
				  value: 'barcode',
				  label: '바코드'
				}, 
				// {
				//   value: 'tracking_no',
				//   label: '트래킹넘버'
				// }, 
				{
				  value: 'order_no',
				  label: '오더넘버'
				}],
				s: 'code',
				k:"",
				options: [],
				status:"AACA",//入库完成 入库保管  
				date1:"",
				date2:"",
				
				total:0,
				current_page:1,
				last_page:1,
				page:1,
				tableData: [],
				dialogFormVisible: false,
				info:{},
				multipleSelection: [],
				repackVisible: false,
				unitTemplates: [],
				repackForm: {
					new_goods_name: '',
					unit_template_id: '',
					produce_qty: 1
				},
				templateDialogVisible: false,
				templateForm: {
					unit_name: '',
					ratio: 1
				}
			}
		},
		computed: {
			isMobile() {
			  return window.innerWidth <= 768;
			}
		},
		created(){
			this.getList()
			//this.getGoodsStatus()
		},
		methods: {
			// submitForm(formName) {
			// 	this.$refs[formName].validate((valid) => {
			// 		if (valid) {
			// 			console.log(this.form,222221111)
			// 			request.post('/member/Inventory/editWarehouse',
			// 				this.form
			// 			).then(response => {
			// 				console.log(response,"")			  
			// 				if(response.code ==1){
			// 					alert('수정 성공！');
			// 					//this.editVisible = false
			// 					console.log('提交成功！');
			// 				}else{
			// 					alert("실패")
			// 					return
			// 				}						
			// 			});				
			// 		}
			// 	})
			// },
			// onEdit(){
			// 	console.log("编辑弹框")
			// 	this.editVisible = true
			// },
			// getGoodsStatus(){
			// 	request.post('/member/Inventory/getGoodsStatus',{})
			// 	.then(res => {
			// 		console.log(res,"status")
			// 		if(res.code ==1){
			// 			this.options= res.data
			// 		}	
			// 	});
			// },
			getList(){
				this.loading = true
				//有问题
				console.log("获取列表")
				request.post('/member/Inventory/getWarehouseList',{
					page:this.page,
					s:this.s,
					k:this.k,
					status:this.status,	
					date1:this.date1,
					date2:this.date2,
				})
				.then(res => {
					this.loading = false
					console.log(res,"212")
					if(res.code ==1){
						this.total = res.data.total
						this.current_page = res.data.current_page
						this.last_page = res.data.last_page
						this.tableData= res.data.data
					}
						
				}).catch(() => {
					this.loading = false
				});
			},
			handleCurrentChange(val) {
			    console.log(`当前页: ${val}`);
				this.page = val
				this.getList()
			},
			changeSearch(){
				this.page = 1
				this.getList()	
			},
			onReset(){
				this.s='code'
				this.k=''
				this.status="AACA"
				this.date1=""
				this.date2=""
	
				this.page = 1
				this.getList()
			},
			getGoodsInfo(id){
				console.log(id,2222)
				request.post('/member/Inventory/getGoodsInfo',{
					id:id,
					data_type:"inventory"
				})
				.then(res => {
					if(res.code ==1){
						console.log(res.data,"详细信息")
						this.info = res.data
					}		
				});
				
			},
			handleEdit(index, row) {
				console.log(index, row);
				this.form = row
				this.dialogFormVisible = true
				this.getGoodsInfo(row.id)
			},
			handleDelete(index, row) {
				console.log(index, row);
				console.log(row.id)
				this.$confirm('정말 삭제하겠습니까?', '', {
				  confirmButtonText: '확인',
				  cancelButtonText: '취소',
				  type: 'warning'
				}).then(() => {
					request.post('/member/Inventory/deleteWarehouse',{
						id:row.id
					})
					.then(res => {
						console.log(res,"")
						if(res.code ==1){
							this.$message({
								type: 'success',
								message: '삭제 성공!'
							});
							this.page = 1
							this.getList()
						}		
					});
					
				}).catch(() => {     
				});
				
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
				this.multipleSelection.forEach(item => {
					if (!item.unit_qty) {
						this.$set(item, 'unit_qty', 1);
					}
				});
			},
			handleRepackApplication() {
				if (this.multipleSelection.length === 0) return;
				this.repackForm = {
					new_goods_name: '',
					unit_template_id: '',
					produce_qty: 1
				};
				if (this.multipleSelection.length === 1) {
					request.post('/member/Inventory/getUnitTemplates', {}).then(res => {
						if(res.code == 1){
							this.unitTemplates = res.data;
						}
					});
				}
				this.repackVisible = true;
			},
			handleTemplateChange(val) {
				if (val && this.unitTemplates.length > 0) {
					const tpl = this.unitTemplates.find(t => t.id === val);
					if (tpl && this.multipleSelection.length > 0) {
						this.multipleSelection[0].unit_qty = tpl.ratio;
					}
				}
			},
			submitRepack() {
				this.$refs.repackForm.validate((valid) => {
					if (valid) {
						let validItems = this.multipleSelection.filter(item => item.stock_qty > 0);
						if (validItems.length === 0) {
							this.$message.error('포장할 구성품이 없습니다. (보유 재고 확인)');
							return;
						}

						for (let i=0; i<validItems.length; i++) {
							let item = validItems[i];
							let need = (item.unit_qty || 1) * this.repackForm.produce_qty;
							if (need > (item.stock_qty || 0)) {
								this.$message.error(`[${item.goods_name}] 재고가 부족합니다.`);
								return;
							}
						}

						let items = validItems.map(item => {
							return {
								source_goods_id: item.id,
								unit_qty: item.unit_qty || 1
							}
						});

						request.post('/member/Inventory/applyRepack', {
							new_goods_name: this.repackForm.new_goods_name,
							unit_template_id: this.repackForm.unit_template_id || 0,
							produce_qty: this.repackForm.produce_qty,
							items: items
						}).then(res => {
							if (res.code == 1) {
								this.$message.success('신청 성공!');
								this.repackVisible = false;
								this.getList();
							} else {
								this.$message.error(res.msg);
							}
						});
					}
				});
			},
			handleShowAddTemplate() {
				this.templateForm = {
					unit_name: '',
					ratio: 1
				};
				this.templateDialogVisible = true;
			},
			submitAddTemplate() {
				this.$refs.templateForm.validate((valid) => {
					if (valid) {
						request.post('/member/Inventory/addUnitTemplate', this.templateForm).then(res => {
							if (res.code == 1) {
								this.$message.success('규격이 추가되었습니다.');
								this.templateDialogVisible = false;
								// 重新加载模板列表
								request.post('/member/Inventory/getUnitTemplates', {}).then(resp => {
									if(resp.code == 1){
										this.unitTemplates = resp.data;
									}
								});
							} else {
								this.$message.error(res.msg);
							}
						});
					}
				});
			}
		}
		
		
	}
	
</script>

<style scoped>
	.widget-location {
	    margin-top: 50px;
	    margin-bottom: 60px;
	    text-align: center;
	}
	.widget-location h3 {
	    padding: 0;
	    margin: 0;
	    font-size: 45px;
	    font-weight: bold;
	    color: var(--frontground-color);
	}
	.condition-wrap{
		padding: 0 20px;	
	}
	.condition-wrap .unit{
		font-weight: bold;
		width:100px;
		padding: 10px 0;
	}

	.table-list{
		margin:30px 0;
	}
	.table-list .page-info{
		font-size: 16px;
		font-weight: bold;
		padding:0 30px 20px;
	}
	.table-list .page-info strong{
		font-weight: normal;
		color: var(--main-color);
	}
	
	.table-list .block{
		padding-top: 20px;
		text-align: center;
	}
	.table-title{
		background-color: #f5f8fd;
		border-top: 1px solid #e3e3e3;
		border-bottom: 1px solid #e3e3e3;
		font-size: 15px;
		min-height: 75px;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 10px;
		box-sizing: border-box;
	}
	.table-content{
		border: 1px solid #e3e3e3;
		font-size: 14px;
		min-height: 75px;
		padding: 10px;
		display: flex;
		align-items: center;
		word-break: break-all;
		overflow-wrap: anywhere;
		box-sizing: border-box;
	}
	.table-content a{
		text-decoration: none;
		color: #337ab7;
	}
	/* 弹框表单 */
	.form-item .item{
		display: flex;
		align-items: center; 
		/* padding-bottom: 20px; */
	}
	.from-title{
		width: 125px;
		padding-bottom: 20px;
	}
	.input-frame{
		width: 200px;
		margin: 0 10px;
	}
	.required-addon{
		font-family: inherit;
		color: var(--main-color);
		font-weight: inherit;
		vertical-align: inherit;
	}
	.icon-question{
		color:var(--main-color);padding-left: 5px;font-size: 18px;
	}
	

	
	.label-warehouse {
	    color: #5cb85c;
	}
	.color-blue {
	    color: #0066ff !important;
	}
	::v-deep .el-table th.el-table__cell {
		text-align: center;
		color:#333;
	}
	.scope-a{
		color: #333;font-weight: 500;text-decoration: none;
	}
	/* 分页背景 */
	::v-deep .el-pager li {
		background-color: #121212;
	}
	::v-deep .el-pagination button:disabled {
		background-color: #121212;
	}
	@media (min-width: 992px) {
		.content-zsy{
			width: 1270px;
			margin: 2.5rem auto;
		}
	}
	@media (max-width: 768px) {
		.s_margin{
			margin:  15px 0;;
		}
		/* 列表 */
		.info-wrap{
			border-top: 2px solid var(--border-color);
			margin:10px 20px;
		}
		.item-info-wrap{
			padding:10px 0;
		}
		.item-info-wrap .item-status {
		    margin-bottom: 1px;
		    font-weight: 600;
		    font-size: 13px;
		    line-height: 20px;
		}
		.item-info-wrap .item-status span {
		    font-weight: normal;
		}
		.item-info-wrap .item-center {
		    font-weight: bold;
		    font-size: 13px;
		    color: #666;
		}
		.item-info-wrap .item-code {
		    color: var(--main-color);
		    font-size: 13px;
		}
		.item-info-wrap .item-goodsname {
		    color: #333;
		    font-size: 13px;
		    line-height: 18px;
		    letter-spacing: -0.01em;
		    font-weight: bold;
		    margin-top: 5px;
		}
		.item-info-wrap .item-goodsname a {
		    color: #333;
			text-decoration: none;
		}
		.item-option-wrap {
			color:#333;
		    padding: 7px 10px 6px;
		    background: #f4f4f4;
		    font-size: 12px;
		    line-height: 19px;
		    letter-spacing: -0.01em;
		}
		.item-quantity-wrap {
			color:#333;
		    display: flex;
		    margin: 10px 0 10px;
		}
		.item-quantity-wrap .item-quantity {
		    flex: 1;
		    align-self: center;
		    background-color: #eff3f9;
		    padding: 7px 10px 6px;
		    display: flex;
		    gap: 5px;
		    justify-content: space-between;
		    flex-wrap: wrap;
		    font-size: 12px;
		}
		.info-wrap .item-date-wrap {
		    font-size: 13px;
		    line-height: 18px;
		    letter-spacing: -0.01em;
		    margin-bottom: 11px;
		}
		
		
	}
	.agency-info-row {
	    display: flex;
	    flex-wrap: wrap;
	    gap: 8px;
	    align-items: center;
	    padding: 4px 0;
	}
	.info-badge {
	    display: inline-flex;
	    align-items: center;
	    border: 1px solid #dcdfe6;
	    border-radius: 6px;
	    overflow: hidden;
	    font-size: 12px;
	    background: #fff;
	    line-height: 1.4;
	    box-shadow: 0 1px 2px rgba(0,0,0,0.02);
	}
	.badge-label {
	    background: #f5f7fa;
	    color: #606266;
	    padding: 5px 10px;
	    border-right: 1px solid #dcdfe6;
	    font-weight: bold;
	    white-space: nowrap;
	}
	.badge-value {
	    padding: 5px 12px;
	    color: #303133;
	    white-space: nowrap;
	}
	.search-card {
		background: #f8fafc;
		border: 1px solid #e2e8f0;
		border-radius: 12px;
		padding: 16px 20px;
		margin-bottom: 24px;
		box-shadow: 0 1px 3px rgba(0,0,0,0.02);
	}
	.search-form-inline {
		display: flex;
		flex-wrap: wrap;
		gap: 16px;
		align-items: center;
	}
	.form-item-group {
		display: inline-flex;
		align-items: center;
		gap: 8px;
	}
	.form-item-label {
		font-size: 13px;
		font-weight: 600;
		color: #475569;
		white-space: nowrap;
		min-width: 60px;
		text-align: right;
	}
	.form-item-input {
		width: 180px !important;
	}
	.form-action-group {
		display: inline-flex;
		align-items: center;
		gap: 10px;
		margin-left: auto;
	}
	@media (max-width: 768px) {
		.form-action-group {
			margin-left: 0;
			width: 100%;
			justify-content: flex-end;
		}
		.form-item-input {
			width: 100% !important;
		}
		.form-item-group {
			width: 100%;
		}
	}
</style>